/**
 * Browser detection for Safari/iOS compatibility with MediaRecorder and screen capture
 */

/** Detect if running on iOS (iPhone, iPad, iPod) */
export function isIOS(): boolean {
  if (typeof navigator === "undefined") return false;
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

/** Detect Safari (including iOS Safari) */
export function isSafari(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  return (
    ua.includes("Safari") && !ua.includes("Chrome") && !ua.includes("Chromium")
  );
}

/** Mime type and extension for recording uploads (Safari uses mp4, others webm) */
export function getRecordingMimeTypeAndExt(): {
  mimeType: string;
  extension: string;
} {
  return isSafari()
    ? { mimeType: "video/mp4", extension: "mp4" }
    : { mimeType: "video/webm", extension: "webm" };
}

/** Safari supports video/mp4 and audio/mp4 for MediaRecorder; WebM is not supported */
export function getMediaRecorderMimeTypes(): string[] {
  const mp4 = ["video/mp4;codecs=avc1,aac", "video/mp4"];
  const webm = [
    "video/webm;codecs=vp9,opus",
    "video/webm;codecs=vp8,opus",
    "video/webm;codecs=h264,opus",
    "video/webm"
  ];
  return isSafari() ? [...mp4, ...webm] : [...webm, ...mp4];
}
